import React from 'react'
import {connect} from 'react-redux'

import Icon from './Icon'

import toggleEstateLike from '../actions/toggleEstateLike'

const preventDefault = (f) => (e) => {
  e.preventDefault()
  e.stopPropagation()
  f(e)
}

const LikeButton = ({like, estateId, onToggleLike}) => {
  return <span className={`like-button ${like ? 'liked' : ''}`} onClick={preventDefault(onToggleLike)}>
      <Icon name={`${like ? 'heart' : 'heart-o'}`}/>
  </span>
}

LikeButton.propTypes = {
  like: React.PropTypes.bool,
  estateId: React.PropTypes.number.isRequired,
  onToggleLike: React.PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch, {estateId, like}) => {
  return {
    onToggleLike:  _ => dispatch(toggleEstateLike(estateId, !like))
  }
}

export default connect(null, mapDispatchToProps)(LikeButton)



/** WEBPACK FOOTER **
 ** ./app/components/LikeButton.jsx
 **/